import $ from "cash-dom";

export const errorComponent = (root = document) => {
    const $root = $(root);

    $root.find('.error').each((i, container) => {
        $(container).children().on('click', () => {
            container.style.display = 'none';
        });
    });
};
